export default __webpack_public_path__ + "static/Segoe UI-45472284dc36b2486ce20fa620c79034.ttf";